export const formatRupiah = (value) => {
  const amount = +`${value ?? 0}`;
  return `Rp. ${Math.round(amount)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
export const parseRupiah = (value) => {
  if (value === void 0) {
    return 0;
  }
  if (typeof value === "string") {
    return +value.replace(/Rp\.\s?|(,*)/g, "");
  }
  return value;
};
export const formatNumber = (value, locale) => {
  return formatDigits(value, 0, locale);
};
export const parseNumber = (value) => {
  if (value === void 0) {
    return 0;
  }
  if (typeof value === "string") {
    return parseFloat(value.replace(",", "."));
  }
  return value;
};
export const formatPercentage = (value, locale, digits = 0) => {
  if (value === void 0) {
    return "0 %";
  }
  if (typeof value === "string") {
    const val = parseFloat(value) * 100;
    const percentage = Intl.NumberFormat(locale, {minimumFractionDigits: digits, maximumFractionDigits: digits}).format(val);
    return `${percentage} %`;
  }
  return `${value} %`;
};
export const parsePercentage = (value) => {
  if (value === void 0) {
    return 0;
  }
  if (typeof value === "string") {
    return parseFloat(value.replace(" %", "").replace(",", ".")) / 100;
  }
  return value;
};
export const formatDigits = (value, digits, locale) => {
  const amount = value === void 0 ? 0 : +value;
  return Intl.NumberFormat(locale, {minimumFractionDigits: digits, maximumFractionDigits: digits}).format(amount);
};
export const formatKwh = (value) => {
  const amount = +`${value ?? 0}`;
  return `kWh ${Math.round(amount)}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
export const parseKwh = (value) => {
  if (value === void 0) {
    return 0;
  }
  if (typeof value === "string") {
    return +value.replace(/kWh\s?|(,*)/g, "");
  }
  return value;
};
